import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import KeyIcon from "@mui/icons-material/Key";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CustomModal from "../../components/CustomModel";
import { MenuItemProps, slotPropsPaper } from "../../theme/PaperProps";
import CustomPopover from "../../components/CustomPopover";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { _logout } from "../../DAL/Login/Auth";
import { useAdminContext } from "../../Hooks/AdminContext";
import ChangePassword from "../../components/ProfileDropDownComponents/ChangePassword";
import EditProfile from "../../components/ProfileDropDownComponents/EditProfile";
import LogoutComponent from "../../components/ProfileDropDownComponents/LogoutComponent";

/**
 * ProfileIcon.jsx
 * Renders the user dropdown menu (profile actions) with options to:
 * - View user name/email
 * - Edit profile
 * - Change password
 * - Logout with confirmation
 */

export default function ProfileIcon({
  anchorEl,
  open,
  handleClose,
  name,
  email,
}) {
  const { STOP_SOCKET_FORCEFULLY } = useAdminContext();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [modelState, setModelState] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [DevicePreference, setDevicePreference] = useState("this");
  const [loading, setLoading] = useState();
  const [openModal, setOpenModal] = useState(false);

  // Closes the modal
  const handleCloseModel = () => {
    setModelState(false);
  };

  /// Opens the modal
  const handleEditProfile = () => {
    setModelState(true);
  };

  // Handles the logout API and UI cleanup
  const handleLogout = async (event) => {
    event.preventDefault();

    setLoading(true);
    const response = await _logout();
    if (response.code === 200) {
      STOP_SOCKET_FORCEFULLY();
      localStorage.removeItem("token");
      localStorage.clear();
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      navigate("/login");
      handleClose();
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  return (
    <div className="Profile-DropDown">
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        slotProps={slotPropsPaper}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          className="Profile-Icon-Link bg-transparent"
          onClick={handleClose}
          sx={MenuItemProps.User_Name}
        >
          {name}
        </MenuItem>
        <MenuItem
          className="Profile-Icon-Link"
          onClick={handleClose}
          sx={MenuItemProps.email_Props}
        >
          {email || "No Email Provided"}
        </MenuItem>
        <Divider /*className="border-1 border-secondary"*/ />
        <MenuItem
          className="Profile-Icon-Link fs-16"
          onClick={() => {
            handleEditProfile();
            handleClose();
          }}
        >
          <ListItemIcon>
            <EditNoteIcon color="primary" />
          </ListItemIcon>
          Edit Profile
        </MenuItem>
        <MenuItem
          className="fs-16 Profile-Icon-Link"
          onClick={() => {
            handleClose();
            setShowChangePassword(true);
          }}
        >
          <ListItemIcon>
            <KeyIcon fontSize="small" color="primary" />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <MenuItem
          className="fs-16 Profile-Icon-Link"
          onClick={() => {
            setOpenModal(true);
            // navigate("/login");
            // enqueueSnackbar("Successfuly Logout", { variant: "success" });
            // handleClose();
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="primary" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <CustomModal
        crossButton={true}
        CustomSpacing={true}
        open={showChangePassword}
        handleClose={() => setShowChangePassword(false)}
        component={
          <ChangePassword handleClose={() => setShowChangePassword(false)} />
        }
      />
      <CustomPopover
        isOpenPop={modelState}
        isClosePop={setModelState}
        handleClose={handleCloseModel}
        title="Edit Profile"
        width={"600px"}
        componentToPassDown={
          <EditProfile
            handleCloseModel={handleCloseModel}
            modelState={modelState}
          />
        }
      />
      <CustomModal
        open={openModal}
        // CustomSpacing={true}
        handleClose={() => setOpenModal(false)}
        component={
          <LogoutComponent
            setDevicePreference={setDevicePreference}
            DevicePreference={DevicePreference}
            loading={loading}
            handleCloseLogoutModal={() => setOpenModal(false)}
            confirmLogout={handleLogout}
          />
        }
      />
    </div>
  );
}
